import axios from 'axios';
import { BASE_URL } from '../Constants/Api';

const API_URL = BASE_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const login = async (userName, password) => {
    const response = await api.post('/auth/authenticate', { userName, password });
    return response.data;
};

export const forgotPassword = async (email) => {
    const response = await api.post(`/auth/forgotpassword?email=${encodeURIComponent(email)}`);
    return response.data;
};

export const resetPassword = async (token, passwords) => {
    const response = await api.put(`/auth/reset?token=${token}`, passwords);
    return response.data;
};

export default api;